import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { IItemConta } from "../../../interfaces/IItemConta";
import { CabecalhoCartao, Cartao, EstadoVazio, TituloCartao } from "../../../../core/styles/superficies";

interface GraficoRoscaProps {
    titulo: string;
    dados: IItemConta[];
    /** Campo do IItemConta plotado nas fatias. */
    chave: "quantidade" | "valorTotal";
    cores: string[];
    formatarTooltip: (valor: number) => string;
    mensagemVazia: string;
    icone: ReactNode;
}

const MAX_FATIAS = 5;

/** Distribuição das 5 maiores fatias, em rosca com legenda. */
export const GraficoRosca = ({
    titulo,
    dados,
    chave,
    cores,
    formatarTooltip,
    mensagemVazia,
    icone,
}: GraficoRoscaProps) => {
    const fatias = dados.slice(0, MAX_FATIAS);

    return (
        <Cartao sx={{ height: 420 }}>
            <CabecalhoCartao>
                <TituloCartao>{titulo}</TituloCartao>
            </CabecalhoCartao>

            {fatias.length ? (
                <Box sx={{ flex: 1, minHeight: 0, padding: 1.5 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={fatias}
                                dataKey={chave}
                                nameKey="descricao"
                                cx="50%"
                                cy="50%"
                                innerRadius={62}
                                outerRadius={96}
                                paddingAngle={2}
                                stroke="none"
                            >
                                {fatias.map((fatia, indice) => (
                                    <Cell
                                        key={`fatia-${fatia.descricao}-${indice}`}
                                        fill={cores[indice % cores.length]}
                                    />
                                ))}
                            </Pie>
                            <Tooltip formatter={(valor: number) => formatarTooltip(valor)} />
                            <Legend
                                verticalAlign="bottom"
                                iconType="circle"
                                iconSize={9}
                                wrapperStyle={{ fontSize: "0.75rem", paddingTop: 8 }}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </Box>
            ) : (
                <EstadoVazio>
                    <Box component="span" sx={{ display: "flex" }}>{icone}</Box>
                    <Typography sx={{ fontSize: "0.8125rem" }}>{mensagemVazia}</Typography>
                </EstadoVazio>
            )}
        </Cartao>
    );
};
